import { createFileRoute } from '@tanstack/react-router';
import { WorkspacePage } from '@/features/workspaces/workspace-page';

export const Route = createFileRoute('/_app/o/$organizationId/_platform/workspaces/$workspaceId')({
    staticData: {
        crumbs: [
            { label: 'shell.organizationSettings', to: '/o/$organizationId/settings' },
            { label: 'shell.crumbWorkspace' },
        ],
    },
    component: function WorkspaceRoute() {
        const { organizationId, workspaceId } = Route.useParams();
        return <WorkspacePage organizationId={organizationId} workspaceId={workspaceId} />;
    },
});
